import { render, staticRenderFns } from "./totalizadorSideBar.vue?vue&type=template&id=706e2476"
import script from "./totalizadorSideBar.vue?vue&type=script&lang=js"
export * from "./totalizadorSideBar.vue?vue&type=script&lang=js"
import style0 from "./totalizadorSideBar.vue?vue&type=style&index=0&id=706e2476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports